export default function(): any {
    return {
        lowerCase: (value: any) => {
            return value.toLowerCase();
        },
        // 对于姓氏名称大小写的规范
        upperToLower: (value: string) => {
            return value.toLowerCase().replace(/^[a-z]/g, function(s: string) {
                return s.toUpperCase();
            });
        }
    };
}
